/**
 * Traductions des cartes « إنشاء مستند » — 6 types (client scope).
 */
export function getPickerCardField(t, docId, field, fallback = '') {
  if (!docId || !field) return fallback;
  const key = `document_creation.picker_cards.${docId}.${field}`;
  const value = t(key);
  return value !== key ? value : fallback;
}

export const CREATE_DOCUMENT_PICKER_DOC_IDS = [
  'quote',
  'proforma',
  'purchase-order',
  'invoice',
  'delivery-note',
  'credit-note',
];

export function buildPickerDocuments(meta, { icons, color, pickerLabel }) {
  return meta.map((d) => {
    const i18nKey = d.pickerI18nKey || d.id;
    return {
      id: d.id,
      title: pickerLabel(i18nKey, 'title', d.title),
      subtitle: pickerLabel(i18nKey, 'subtitle', d.subtitle),
      description: pickerLabel(i18nKey, 'description', d.description),
      icon: icons[d.id],
      color,
      supplierCreditNote: d.supplierCreditNote,
    };
  });
}
